module.exports = __webpack_public_path__ + "img/pr-14.2842c4ee.png";